import { render, staticRenderFns } from "./DynamicDomainNameShow.vue?vue&type=template&id=7d6d48f4&"
import script from "./DynamicDomainNameShow.vue?vue&type=script&lang=js&"
export * from "./DynamicDomainNameShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports